// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 21/08/2023

import { Component, OnDestroy, OnInit } from '@angular/core'
import { BaseController } from './base.controller';
import { Router } from '@angular/router';
import { Action, ApiResponseModel, AuthService, CtOtpComponent, CtRadioComponent, CtStepperComponent, CtStepperItemComponent, EntityField } from 'components';
import { Subscription } from 'rxjs';

@Component({
	selector: 'sg-vi02',
	template: `<div [id]="getId()" #target><div>`
})

export class SgVi02 extends BaseController implements OnInit, OnDestroy{

	//constants
	public readonly EMAIL_TEXT : string = 'Enviar un correo a ';
	public readonly SMS_TEXT : string = 'Enviar un mensaje de texto al ';
	private readonly USER_ROLES : Set<string> = new Set(['ADMINISTRACION_PLANILLAS',
	 'TESORERIA_PLANILLAS', 'PLANILLERO_ROLE']);

	//properties
	private userPreviewData : any;
	private radioComponents : CtRadioComponent[] = [];
	private otpComponent : CtOtpComponent;
	private subscriptions : Subscription[] = [];

	constructor(private router : Router,
		private authService : AuthService) {
		super();
		this.setViewCode('SG_VI02');
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((subscription : Subscription) => subscription.unsubscribe());
	}

	ngOnInit(): void {
		this.subscriptions.push(this.authService.userRoles$.subscribe({
			next : (data : string[]) => {
				if(data.some((role : string) => this.USER_ROLES.has(role))) {
					this.router.navigate(['/home/view/PA_VI01']);
					this.otpComponent.isExecuting = false;
				} else {
					this.router.navigate(['/home']);
					this.otpComponent.isExecuting = false;
				}
			}
		}));
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */

	public manageUserPreviewData(action : Action) : void {
		this.storeService.getStateObservable('userPreviewData').subscribe({
			next: (data) => {
				this.userPreviewData = data;
				this.setUserContacts(action);
			}
		});
	}

	public setUserContacts(action : Action): void {
		let stepperItem : CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[0]);
		this.authService.getLoginPreviewInfoAuthSva(this.userPreviewData.userId).subscribe({
			next: (data : ApiResponseModel) => {
				this.setStepperItemModels(data['Data'][0].ArrayEntities.List, stepperItem);				
			}
		});
	}

	private setStepperItemModels(arrayEntitiesList: EntityField[], stepperItem: CtStepperItemComponent) {
		let radioComponentsMetadata : any[] = [];
		arrayEntitiesList = arrayEntitiesList.filter((element : EntityField) => element.Name === 'EMAIL' || element.Name === 'CELULAR');

		for(let [index, element] of arrayEntitiesList.entries()) {
			if(element.Value === '' ||
				element.Value === null || 
				element.Value === undefined ||
				element.Value.toUpperCase() === 'NULL') continue;
			radioComponentsMetadata.push(this.getRadioComponentMetadata(element, index, element.Name));
		}
		this.paintRadioComponents(radioComponentsMetadata, stepperItem);
	}

	private getRadioComponentMetadata(element: EntityField, index : number, type : string): any {
		return {
			ctType: "CtRadio",
			controlProperties: {
			  hidden: false,
			  listenedComponentId: "",
			  listenedProperty: "",
			  border: true,
			  isChecked: false,
			  readOnly: false,
			  labelValue: type === 'EMAIL' ? this.EMAIL_TEXT + element.Value : this.SMS_TEXT + element.Value,
			  value: element,
			  descriptionValue: "",
			  familyValue: "userContacts",
			  id: `MFA_LOGIN_CONTACTS_${index}`,
			  modelId: ""
			},
			controlActions: [],
			models: []
		};
	}

	private paintRadioComponents(radioComponentsMetadata: any[], stepperItem: CtStepperItemComponent) {
		let metadata : any = stepperItem.getMetaData();
		metadata.models = radioComponentsMetadata;
		stepperItem.ngAfterViewInit();
		this.radioComponents = stepperItem.getChildElements() as CtRadioComponent[];
	}

	public setDataToOtp(action : Action) : void {
		const stepper : CtStepperComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const otp : CtOtpComponent = this.utilService.getComponentRef(action.actionParams[1]);
		this.otpComponent = otp;
		const selectedRadioValue : EntityField = this.getSelectedRadioValue();
		if(!selectedRadioValue) return;
		otp.setDataToOtp(selectedRadioValue.Value, selectedRadioValue.Name, this.userPreviewData.userId);
		otp.sendCode();
		stepper.changeStep(stepper.getCurrentIndex() + 1);
	}

	private getSelectedRadioValue(): EntityField {
		let selectedRadioValue : EntityField = null;
		for(let radioComponent of this.radioComponents) {
			if(radioComponent.getIsChecked()) {
				selectedRadioValue = radioComponent.getValue();
				break;
			}
		}
		return selectedRadioValue;
	}

	public returnToLogin(): void {
		this.router.navigate(['/login']);
	}

	public validateOtpCode(): void {
		if(this.otpComponent.getOtpCodeFromInput() === '') return;
		this.otpComponent.validateOtpCode();
	}

	public postOtpValidation(): void {
		this.authService.logIn(this.userPreviewData.userId, this.userPreviewData.password).subscribe({
			next: () => {
				this.storeService.deleteState('userPreviewData');
		}});
	}
	/* -------------------- END CONTROLLER LOGIC ----------------- */
}